import React from 'react';

import {BaseMainTitle} from "../base-title/base.main-title";
import {BaseSideTitle} from "../base-title/base.side-title";
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "./card-title.module.scss";
import {TAG_TITLE} from "../../../app/consts";

export const CardTitle = observer(({
                                     controller,
                                     title,
                                     entity,
                                     bookmaker,
                                     className,
                                     ElementComponent,
                                     source,
                                     sportTypeId,
                                     onClick,
                                     TitleTag,
                                     shouldRenderSideElement = true
                                   }) => {
  const titleTag: String = TitleTag || (controller?.device?.isSmallView ? TAG_TITLE.h2 : TAG_TITLE.h3);

  const containerProps = {
    className: classNames(styles.title_container,
        {[styles.small_view]: controller?.device?.isSmallView},
        {[styles.no_entity]: !entity}, className),
    onClick: () => onClick?.()
  }

  const mainProps = {
    title,
    entity,
    controller,
    className: styles.title,
    TitleTag: titleTag,
    source
  }

  const sideProps = {
    controller,
    bookmaker,
    ElementComponent,
    source,
    sportTypeId
  }

  return (
      title || entity ? <div {...containerProps}>
        <BaseMainTitle {...mainProps}/>
        {
          shouldRenderSideElement ? <BaseSideTitle {...sideProps}/> : null
        }
      </div> : null
  );
});

